import Routine, { RUN } from "@bloglovin/inspire-engine/Routine";

/**
 * PowerOffVm — user-initiated VM power-off.
 *
 * Server-only: the real work is the GCP devbox destroy in
 * PowerOffVm.php. Registered on the client for engine PHP/JS parity
 * and so the <EntityAction> fires the event optimistically; the
 * browser holds no GCP credentials, so the client counterpart is a
 * no-op. The server's SetProjectVmStatus(off) broadcast flips the panel.
 */
export default class PowerOffVm extends Routine {
  // Client no-op stub: the server (PowerOnVm.php / PowerOffVm.php) resolves
  // + validates the real params (vmName/gcpProject/stateBucket/createScriptPath)
  // and does the GCP work. The old assertObjectKeyExists("project") check was
  // stale from a prior param design and threw before the transaction could post.
  assertValidParams() {}

  [RUN]() {
    return null;
  }
}

Routine.register("PowerOffVm", PowerOffVm);
